import ContainerStore from './container';

// Pending cart store
export default class PendingCartStore extends ContainerStore {}
